import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { MariaDBCopySource } from 'app/model/pipeline/copysource/maria-db.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MariaDBCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MariaDBCopySourceAdapter extends CopySourceAdapter<MariaDBCopySource, Model.MariaDBSource> {
    protected override async _toResource(copySource: MariaDBCopySource): Promise<Model.MariaDBSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(MariaDBCopySource).name);
    }

    protected override async _toModel(
        resource: Model.MariaDBSource,
        copyActivity: CopyActivity
    ): Promise<MariaDBCopySource> {
        return this._toTabularModel(resource, copyActivity, MariaDBCopySource.MODEL);
    }
}
